export default "__VITE_ASSET__D6nIw7GV__"